import type { HearingLossRecipe } from 'common/interfaces/hearingLoss';
import { fetchJson } from '../../store/fetch';

export function downloadHearingLossRecipe(processActivityId: string): void {
    window.open(`/api/patient/hearingLoss/recipes/${processActivityId}`, '_blank');
}

export async function getHearingLossRecipes(): Promise<HearingLossRecipe[]> {
    const result = await fetchJson('/api/patient/hearingLoss/recipes', 'GET');

    return result.json;
}
